import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FenceTable = _resolveComponent("FenceTable");
  return _openBlock(), _createBlock(_component_FenceTable, {
    ref: "refTable",
    onAdd: _cache[0] || (_cache[0] = $event => _ctx.$emit('add', $event)),
    onRowClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('rowClick', $event))
  }, null, 512);
}